// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1LvqS","label":"SetPasswdForm_label__3A8DF"};